import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { t } from "@/lib/i18n";
import { useAuth } from "@/context/AuthContext";
import { Wordmark } from "@/components/Brand";

export { Wordmark };

const PRIMARY = [
  ["/how-it-works", "nav.howItWorks"],
  ["/who-can-receive-care", "nav.who"],
  ["/our-counselors", "nav.counselors"],
  ["/life-care-classes", "nav.classes"],
  ["/resources", "nav.resources"],
  ["/reach-out", "nav.reachOut"],
];
const MORE = [["/pray-with-us", "nav.pray"], ["/crisis", "nav.crisis"], ["/faq", "nav.faq"]];

export const PublicHeader = () => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const linkClass = ({ isActive }) => `tap whitespace-nowrap px-2.5 rounded text-sm text-cream-50 hover:bg-cream-50/10 ${isActive ? "underline underline-offset-8 decoration-sage-400 decoration-2" : ""}`;
  const accountHref = user ? (user.is_staff ? "/staff" : "/portal") : "/sign-in";
  const accountLabel = user ? (user.is_staff ? t("nav.staffConsole") : t("nav.myCare")) : t("nav.signIn");

  return (
    <header className="bg-olive-900 text-cream-50 border-b border-olive-700" data-testid="public-header">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
        <Wordmark sub="wide" />
        <nav className="hidden xl:flex items-center gap-0.5" aria-label="Primary">
          {PRIMARY.map(([to, key]) => (
            <NavLink key={to} to={to} className={linkClass} data-testid={`nav-${to.slice(1)}`}>{t(key)}</NavLink>
          ))}
        </nav>
        <div className="hidden xl:flex items-center gap-2 shrink-0">
          <Link to={accountHref} className="btn-outline-on-olive min-h-[40px] py-1.5 px-4 whitespace-nowrap" data-testid="nav-account-link">{accountLabel}</Link>
          <Link to={user ? "/portal" : "/sign-up"} className="btn-on-olive min-h-[40px] py-1.5 px-4 whitespace-nowrap" data-testid="nav-get-care-button">{t("nav.getCare")}</Link>
        </div>
        <button type="button" className="tap xl:hidden rounded text-cream-50 hover:bg-cream-50/10" aria-expanded={open} aria-controls="mobile-menu" onClick={() => setOpen((v) => !v)} data-testid="mobile-menu-button">
          {open ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
          <span className="sr-only">{open ? t("nav.closeMenu") : t("nav.menu")}</span>
        </button>
      </div>
      {open && (
        <nav id="mobile-menu" className="xl:hidden border-t border-olive-700 px-4 pb-6 pt-2 sm:px-6" aria-label="Mobile" data-testid="mobile-menu">
          <ul className="flex flex-col">
            {[...PRIMARY, ...MORE].map(([to, key]) => (
              <li key={to}>
                <NavLink to={to} onClick={() => setOpen(false)} className="tap w-full justify-start px-2 text-lg text-cream-50 hover:bg-cream-50/10 rounded" data-testid={`mobile-nav-${to.slice(1)}`}>{t(key)}</NavLink>
              </li>
            ))}
          </ul>
          <div className="mt-4 flex flex-col gap-2">
            <Link to={accountHref} onClick={() => setOpen(false)} className="btn-outline-on-olive" data-testid="mobile-account-link">{accountLabel}</Link>
            <Link to={user ? "/portal" : "/sign-up"} onClick={() => setOpen(false)} className="btn-on-olive" data-testid="mobile-get-care-button">{t("nav.getCare")}</Link>
          </div>
        </nav>
      )}
    </header>
  );
};
